import {
	AnnouncementApi,
	AnnouncementCreateUpdateDTO,
	AnnouncementDTO,
	AnnouncementForUserDTO,
} from "../Api";
import { getAuthConfiguration } from "./configuration";

const AuthAnnouncementApiFactory = () =>
	new AnnouncementApi(getAuthConfiguration());

export interface GetAnnouncementsParams {
	searchTerm?: string;
	page?: number;
	pageSize?: number;
}

export const getAnnouncements = (params: GetAnnouncementsParams) => {
	const { searchTerm, page, pageSize } = params;
	return AuthAnnouncementApiFactory().apiAnnouncementGetAnnouncementsGet({
		searchTerm,
		page,
		pageSize,
	});
};

export const getAnnouncementById = (id: string): Promise<AnnouncementDTO> => {
	return AuthAnnouncementApiFactory().apiAnnouncementGetAnnouncementByIdAnnouncementIdGet(
		{
			announcementId: id,
		}
	);
};

export const getAnnouncementsForCurrentUser = (): Promise<
	AnnouncementForUserDTO[]
> => {
	return AuthAnnouncementApiFactory().apiAnnouncementGetForCurrentUserGet();
};

export const createAnnouncement = async (
	dto: AnnouncementCreateUpdateDTO
): Promise<void> => {
	await AuthAnnouncementApiFactory().apiAnnouncementCreatePost({
		announcementCreateUpdateDTO: dto,
	});
};

export const updateAnnouncement = async (
	id: string,
	dto: AnnouncementCreateUpdateDTO
): Promise<void> => {
	await AuthAnnouncementApiFactory().apiAnnouncementUpdateAnnouncementIdPut({
		announcementId: id,
		announcementCreateUpdateDTO: dto,
	});
};

export const deleteAnnouncement = async (id: string): Promise<void> => {
	await AuthAnnouncementApiFactory().apiAnnouncementDeleteAnnouncementIdDelete({
		announcementId: id,
	});
};
